export function writeLocalStorage(key: string, data: string): boolean {
    try {
        localStorage.setItem(key, data);

        return true;
    } catch (_e) {
        return false;
    }
}

export function readLocalStorage(key: string): string | null | undefined {
    try {
        return localStorage && localStorage.getItem(key);
    } catch (_e) {
        return undefined;
    }
}

export function removeLocalStorageItem(key: string): boolean {
    try {
        localStorage.removeItem(key);

        return true;
    } catch (_e) {
        return false;
    }
}
